function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.411 4.999L8.742 7.33a1 1 0 01-1.413 1.414L4.998 6.413 2.666 8.744a.998.998 0 01-1.413 0 .997.997 0 010-1.414l2.331-2.331-2.331-2.331a.997.997 0 010-1.414.998.998 0 011.413 0l2.332 2.331 2.331-2.331a1 1 0 011.413 1.414L6.411 4.999z"
});

var SvgDel = function SvgDel(props) {
  return React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDEwIDEwIj4KICAgIDxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNi40MTEgNC45OTlMOC43NDIgNy4zM2ExIDEgMCAwIDEtMS40MTMgMS40MTRMNC45OTggNi40MTMgMi42NjYgOC43NDRhLjk5OC45OTggMCAwIDEtMS40MTMgMCAuOTk3Ljk5NyAwIDAgMSAwLTEuNDE0bDIuMzMxLTIuMzMxLTIuMzMxLTIuMzMxYS45OTcuOTk3IDAgMCAxIDAtMS40MTQuOTk4Ljk5OCAwIDAgMSAxLjQxMyAwbDIuMzMyIDIuMzMxIDIuMzMxLTIuMzMxYTEgMSAwIDAgMSAxLjQxMyAxLjQxNEw2LjQxMSA0Ljk5OXoiLz4KPC9zdmc+Cg==";
export { SvgDel as ReactComponent };